/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {BundleTypeEnum} from '../bundles-main-page/data/bundle-type.enum';
import {CustomerTypeEnum} from '../bundles-main-page/data/customer-type.enum';

@Injectable({
    providedIn: 'root'
})
export class SelectedTabsService {
    public bundleType: BundleTypeEnum = BundleTypeEnum.UNKNOWN;
    public bundleTypeAcronym: string = null;
    public customerCode: string = null;
    public customerAcronym: string = null;
}
